import React, { useState, useEffect } from 'react';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { getDoc, addDoc, collection, query, getDocs, deleteDoc, doc, where } from 'firebase/firestore';
import { db } from '../../firebase-config';
import axios from 'axios';

export default function FileUpload({isAdmin, selectedCompany, selectedYear, auth}) {
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const storage = getStorage();

  useEffect(() => {
    fetchFiles();
  }, [selectedCompany, selectedYear, auth]);

  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file.');
      return;
    }
  
    if (selectedFile.type !== 'application/pdf') {
      alert('Only PDF files are allowed.');
      return;
    }
  
    const timeStamp = new Date().getTime();
    const filePath = `documents/${selectedFile.name}_${timeStamp}`;
    const fileRef = ref(storage, filePath);
    
   
    await uploadBytes(fileRef, selectedFile)
      .then(() => {
        
        addFileToFirestore(filePath);
      })
      .catch((error) => {
        console.error("There was an error uploading the file:", error);
      });
  };
  
  const deleteFileFromStorage = async (filePath) => {
    
    const fileRef = ref(storage, filePath);
    return deleteObject(fileRef); 
  };
  
  const deleteFileFromFirestore = async (fileId) => {
    
    const docRef = doc(db, 'filesCollection', fileId);
    return deleteDoc(docRef); 
  };
  
  const handleDelete = async (filePath, fileId) => {
    try {
      
      await deleteFileFromStorage(filePath);
      await deleteFileFromFirestore(fileId);
      setFiles(files => files.filter(file => file.id !== fileId));
    } catch (error) {
      console.error('Error deleting the file:', error);
    }
  };
  
  
  

  const addFileToFirestore = async (filePath) => {
    const newFile = { path: filePath, name: selectedFile.name, company: selectedCompany, year:selectedYear };
    const newDocRef = await addDoc(collection(db, 'filesCollection'), newFile);
    const newDocSnapshot = await getDoc(newDocRef);
    const fileId = newDocSnapshot.id;
    const updatedFile = { ...newFile, id: fileId };
    setFiles((prevFiles) => [...prevFiles, updatedFile]);
  };
  const fetchFiles = async () => {
    const q = query(collection(db, 'filesCollection'), where("company", "==", selectedCompany),  where("year", "==", selectedYear));
    const querySnapshot = await getDocs(q);
    const fetchedFiles = [];
    querySnapshot.forEach((doc) => {
      const fileData = doc.data();
      fetchedFiles.push({ ...fileData, id: doc.id });
    });
  
    setFiles(fetchedFiles);
  };
  const openFile = async (filePath) => {
    const fileRef = ref(storage, filePath);
    const url = await getDownloadURL(fileRef);

    axios.get(url, { responseType: 'blob' })
      .then((response) => {
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch((error) => {
        console.error('Error fetching the file:', error);
      });
  };

  return (
<div className="file-upload-container">
  {isAdmin ? (<div className='row'>
        <input type="file" accept=".pdf" onChange={(e) => setSelectedFile(e.target.files[0])} className="file-input" />
        <button className='upload-btn' onClick={handleFileUpload}>Upload</button></div>) : (<div></div>)} 
        <ul className="file-list">
            {files.map((file, index) => (
                <li key={index} className="file-list-item">
                    <button className='open-file-btn' onClick={() => openFile(file.path)}>{file.name}</button>
                    {isAdmin &&
                        <button className='delete-btn' onClick={() => handleDelete(file.path, file.id)}>Delete</button>
                    }
                </li>
            ))}
        </ul>
    </div>
  );
}
